import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';

// i just used this to style the icons
let iconStyle ={
    fontSize:'16px',
    color: 'black',
    marginRight: '11px',
}
 const ProfileData = {

    name: 'Anthony Michael',
    title: 'Software Engineer',
    jobDescription: 'Frontend Developer',
    birthday: '08 October',
    job: 'Freelancer',
    email: 'tee.jhay1@gmail.com',
    address: 'Opp Club 99 , Karu Abuja',
    phone: '090-1940-4392',

    socials: {
        whatsapp:{
            link:'https://wa.me/+2349019404392',
            text:'Tony Mike',
            icon: <WhatsAppIcon sx={iconStyle}
            />
        },
        twitter:{
            link:'https://twitter.com/yorubadeveloper',
            text:'@YorubaDeveloper',
            icon: <TwitterIcon sx={iconStyle}/>
        },
        linkedin:{
            link:'https://linkedin.com/in/tony-michael-5b25a3103',
            text:'Linkedin',
            icon: <LinkedInIcon sx={iconStyle}/>
        },
        github:{
            link:'https://github.com/TonyMike',
            text:'TonyMike',
            icon: <GitHubIcon sx={iconStyle}/>
        },        
    }
}

export default ProfileData